import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import { forArrayLength } from "../misc/helperfuncs";

const getNewObject = (player, type, getBoxType) => {
  const boxType = getBoxType(type);
  const object = {
    id: "",
    type,
    shortDescription: "",
    longDescription: "",
    image: null,
    categories: [],
    keywords: [],
    ratings: {
      first: { name: boxType.ratings.general.first.general.name, rating: 0 },
      second: { name: boxType.ratings.general.second.general.name, rating: 0 },
    },
    things: [],
  };
  if (type == "goal") object.time = 0;
  forArrayLength(boxType.related.types, (r) => {
    object[r] = [];
  });

  return object;
};

const makeBoxType = () => {
  return {
    names: { singular: "", plural: "" },
    colors: { primary: "", secondary: "", text: "" },
    descriptions: {
      shortDescription: "",
      longDescription: "",
      image: "",
      categories: "",
      keywords: "",
      things: "",
    },
    icon: "",
    ratings: {
      general: {
        first: {
          general: { name: "", hint: "", icon: null },
          personal: { name: "", hint: "" },
        },
        second: {
          general: { name: "", hint: "", icon: null },
          personal: { name: "", hint: "" },
        },
      },
      active: {
        first: { name: "", hint: "", icon: null },
        second: { name: "", hint: "", icon: null },
      },
      completed: {
        first: { name: "", hint: "", icon: null },
        second: { name: "", hint: "", icon: null },
      },
    },
    related: {
      types: [],
      descriptions: {},
    },
    points: false,
    completed: "",
    time: null,
    used: 1,
  };
};

export { getNewObject, makeBoxType };
